import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import InstallDesktopIcon from "@mui/icons-material/InstallDesktop";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

// "Instalar app" (PWA): Chrome/Edge/Android disparam o beforeinstallprompt, capturado
// cedo em src/index.js (window.__installPrompt) porque ele chega antes do layout
// montar. iPhone/iPad não tem esse evento: o botão mostra o passo a passo do Safari.
// Já instalado (aberto como app) ⇒ o botão não aparece.
const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const InstallAppButton = ({ comoItem, aoEscolher }) => {
  const [prompt, setPrompt] = useState(window.__installPrompt || null);
  const [installed, setInstalled] = useState(isStandalone());
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => {
    const onAvailable = () => setPrompt(window.__installPrompt || null);
    const onInstalled = () => {
      setPrompt(null);
      setInstalled(true);
    };
    window.addEventListener("app:installable", onAvailable);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("app:installable", onAvailable);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;
  const ios = isIOS();
  if (!prompt && !ios) return null;

  const handleClick = async () => {
    if (!prompt) {
      setIosHelp(true);
      return;
    }
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    // o mesmo evento não pode ser reaproveitado; o navegador manda outro se ainda couber
    window.__installPrompt = null;
    setPrompt(null);
    if (outcome === "accepted") setInstalled(true);
  };

  return (
    <>
      {comoItem ? (
        <MenuItem onClick={() => { handleClick(); if (aoEscolher && prompt) aoEscolher(); }}>
          <ListItemIcon><InstallDesktopIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Instalar o app</ListItemText>
        </MenuItem>
      ) : (
      <Tooltip title="Instalar o SabeZap como app">
        <IconButton
          onClick={handleClick}
          color="inherit"
          sx={{ borderRadius: "50%", padding: 0.75, "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" } }}
        >
          <InstallDesktopIcon />
        </IconButton>
      </Tooltip>
      )}
      <Dialog open={iosHelp} onClose={() => setIosHelp(false)} maxWidth="xs">
        <DialogTitle>Instalar o SabeZap no iPhone</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>1. Abra esta página no <b>Safari</b>.</Typography>
          <Typography gutterBottom>2. Toque em <b>Compartilhar</b> (o quadrado com a seta para cima).</Typography>
          <Typography gutterBottom>3. Escolha <b>Adicionar à Tela de Início</b> e confirme.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIosHelp(false)}>Entendi</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InstallAppButton;
